import {Injectable} from '@angular/core';
import {CacheService} from '@ngx-cache/core';
import {CookieService} from 'ngx-cookie';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
    private accessToken: string;
    private refreshToken: string;

    constructor(
        private cacheService: CacheService,
        private cookieService: CookieService
    ) {
        this.accessToken = this.cacheService.get('oauth_access_token');
        this.refreshToken = this.cacheService.get('oauth_refresh_token');
    }

    hasAccessToken() {
      if (this.cacheService.has('oauth_access_token')) {
        return !!this.accessToken;
      } else {
        return this.cookieService.get('oauth_access_token');
      }
    }

    hasRefreshToken() {
        return !!this.refreshToken;
    }

    getAccessToken() {
      if (this.cacheService.has('oauth_access_token')) {
        return this.accessToken;
      } else {
        return this.cookieService.get('oauth_access_token');
      }
    }

    getRefreshToken() {
        return this.refreshToken;
    }

    store(access: string, refresh: string, isRemember = false) {
        this.accessToken = access;
        this.refreshToken = refresh;
        if (isRemember) {
          this.cacheService.set('oauth_access_token', this.accessToken);
          this.cacheService.set('oauth_refresh_token', this.refreshToken);
        } else {
          const date = new Date();
          date.setHours(date.getHours() + 1);
          this.cookieService.put('oauth_access_token', this.accessToken, {expires: date});
        }
    }

    clearAccessToken() {
        this.accessToken = '';
    }

    clear() {
        this.accessToken = null;
        this.refreshToken = null;
        if (this.cacheService.has('oauth_access_token')) {
          this.cacheService.remove('oauth_access_token');
          this.cacheService.remove('oauth_refresh_token');
        } else {
          this.cookieService.remove('oauth_access_token');
        }
    }
}
